import type { Cashier } from "@/services/sharedTypes/cashiers"
import api from "@/services/api"

export const retrieveCashier = async (
  cashierId: string
): Promise<Cashier> => {
  const response = await api.get<Cashier>(
    `/cashiers/${cashierId}`
  )
  return response.body
}
